import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  // Close modal when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    }
    // Close modal when pressing Escape key
    function handleEscapeKey(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        onClose();
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscapeKey);
      // Prevent scrolling on the body when modal is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70" data-id="element-138">
      <div ref={modalRef} className="bg-gray-900 border border-orange-800/30 rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden" data-id="element-139">
        <div className="flex items-center justify-between border-b border-orange-800/30 p-4" data-id="element-140">
          <h2 className="text-xl font-bold text-orange-300" data-id="element-141">{title}</h2>
          <button onClick={onClose} className="text-orange-300/70 hover:text-orange-300 transition-colors" data-id="element-142">
            <XIcon size={24} data-id="element-143" />
          </button>
        </div>
        <div className="p-6" data-id="element-144">{children}</div>
      </div>
    </div>;
}